import SourceMapping from './SourceMapping';

export default SourceMapping;
